import type { RegisteredComponent } from "@builder.io/sdk-react";

import { MainNav } from "./main-nav";

export const MainNavDefinition = {
  component: MainNav,
  name: "MainNavigation",
  noWrap: true,
  inputs: [],
} satisfies RegisteredComponent;
